/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Generation
 */
export interface Generation {
    /**
     * 
     * @type {number}
     * @memberof Generation
     */
    maxYear: number;
    /**
     * 
     * @type {number}
     * @memberof Generation
     */
    minYear: number;
}

/**
 * Check if a given object implements the Generation interface.
 */
export function instanceOfGeneration(value: object): value is Generation {
    if (!('maxYear' in value) || value['maxYear'] === undefined) return false;
    if (!('minYear' in value) || value['minYear'] === undefined) return false;
    return true;
}

export function GenerationFromJSON(json: any): Generation {
    return GenerationFromJSONTyped(json, false);
}

export function GenerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Generation {
    if (json == null) {
        return json;
    }
    return {
        
        'maxYear': json['maxYear'],
        'minYear': json['minYear'],
    };
}

export function GenerationToJSON(value?: Generation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxYear': value['maxYear'],
        'minYear': value['minYear'],
    };
}

